
import { Outlet, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import Stack from '@mui/joy/Stack';
import NewProjectForm from './NewProjectForm';
import ProjectHeader from './ProjectHeader';


const ProjectContainer = observer(() => {

    const projectKey = useParams<{projectKey: string}>().projectKey;
    if(projectKey === 'new') {
        return <NewProjectForm />
    }
    return (
        <Stack sx={{
			display: 'flex',
            flexGrow: 1,
            //            margin: 0,
        }} >
            { false &&
            <ProjectHeader  />
            }
                <Outlet />

        </Stack>
    );

});



export default ProjectContainer;
